import React from 'react';
import { Box, Typography, Divider, Grid } from '@mui/material';
import { deviceWidth } from '../../../utils/settings'; // Assuming this utility is available

const StatusContainer = ({ StatusData }) => {
  const formattedStatuses = Object.values(StatusData || {}).filter(
    (item) => typeof item === 'object',
  );

  const renderStatusCard = (
    label,
    value,
    subtext,
    color,
    prefix_uom,
    suffix_uom,
  ) => (
    <Box sx={{ textAlign: 'center', p: 1 }}>
      <Typography sx={{ fontSize: 14, fontWeight: '500' }}>{label}</Typography>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'row',
            sm: 'row',
            md: 'column',
            lg: 'column',
          },

          justifyContent: 'center',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Typography sx={{ fontSize: 11, fontWeight: '400' }}>
          {prefix_uom}
        </Typography>
        <Typography
          sx={{
            color: color,

            fontWeight: 18,
            fontWeight: '700',
          }}
        >
          {value ? value : '0'}
        </Typography>
        <Typography sx={{ fontSize: 11, fontWeight: '400' }}>
          {suffix_uom}
        </Typography>
      </Grid>

      <Typography sx={{ fontSize: 12, fontWeight: '400' }}>
        {subtext}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        // p: 2,
        boxShadow: 2,
        marginTop: 2,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      {formattedStatuses.map((status, index) => (
        <React.Fragment key={index}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                position: 'relative',
                top: 0,
              }}
            >
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  backgroundColor: status.color,
                  marginBottom: 1,
                  position: 'absolute',
                  left: '30%',
                }}
              />
              <Box
                sx={{
                  width: 50,
                  height: 3,
                  backgroundColor: status.color,
                  marginBottom: 1,
                }}
              />
            </Box>

            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                minHeight: 100,
              }}
            >
              <Box sx={{ flex: 1, flexDirection: 'row' }}>
                {renderStatusCard(
                  status.primary_display_title,
                  status.quantity,
                  status.secondary_display_title,
                  status.color,
                  status.prefix_uom,
                  status.suffix_uom,
                )}
              </Box>
            </Box>
          </Box>
          {index < formattedStatuses.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default StatusContainer;
